import React from "react";
import { useLang } from "../LanguageContext";
import { useSettings } from "../SettingsContext";

const DAY_ORDER = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

export default function HoursTable({ compact = false }) {
  const { t } = useLang();
  const { settings } = useSettings();
  const hours = settings.hours || {};
  return (
    <div data-testid="hours-table" className={compact ? "space-y-2" : "space-y-3"}>
      {DAY_ORDER.map((d) => {
        const h = hours[d] || {};
        return (
          <div key={d} className="flex justify-between items-baseline gap-4 border-b border-border/50 pb-2">
            <span className="text-sm text-foreground/90 font-medium">{t.hours.days[d]}</span>
            <span className={`text-sm font-light ${h.closed ? "text-muted-foreground italic" : "text-primary qw-num"}`}>
              {h.closed ? t.hours.closed : `${h.open} – ${h.close}`}
            </span>
          </div>
        );
      })}
    </div>
  );
}
